import axios from 'axios';
import * as Constants from '../common/constants';
import AuthService from './authService';
import * as HelperFunctions from '../common/functions/helperFunctions';

class GraphQLService {
    authService = new AuthService();

    constructor() {
        axios.defaults.headers = {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: `Bearer ${this.authService.getToken()}`,
            Pragma: 'no-cache',
        }
    }

    getData(query, variables?) {
        return axios({
            url: `${Constants.apiUrl}/graphql/`,
            method: 'post',
            data: {
                query: query,
                variables: variables
            }
        })
            .then(res => {
                if (res.data.errors) {
                    if (res.data.errors[0].path) {
                        if (res.data.errors[0].path.length > 0 && res.data.errors[0].path.some(p => p === "BUSINESS_VALIDATION")) {
                            throw new Error(res.data.errors[0].extensions.code);
                        }
                    }
                    throw new Error(res.data.errors[0].message);
                }
                else {
                    return res.data;
                }
            })
            .catch(error =>
                Promise.reject(HelperFunctions.getErrorMessage(error)));
    }
}


export default GraphQLService;